// extracted by mini-css-extract-plugin
export default {"container":"MessageList_container__vaQDM","cardContainer":"MessageList_cardContainer__VNWTC"};